import { scrollToSection } from "@/hooks/useLenis";

const STORAGE_KEY = "cp_lead_prefill";

export function openLeadForm(prefill = {}) {
  if (typeof window !== "undefined" && prefill.message) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prefill));
  }
  scrollToSection("#enquire");
  window.setTimeout(() => {
    document.getElementById("lf-name")?.focus({ preventScroll: true });
  }, 600);
}

export function consumeLeadPrefill() {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(STORAGE_KEY);
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
